// teamData.ts
import mudasir from "../assets/images/mudasir.jpeg";
import rayees from "../assets/images/rayees.jpeg";


interface TeamMember {
    name: string;
    position: string;
    description: string;
    src: string;
  }
  
  const teamData: TeamMember[] =
  [
    {
        name: "Mudasir Reshi",
        position: "Founder & CEO",
        src: mudasir,
        description:
            "The visionary Founder and CEO, brings over a decade of experience in travel and tourism to the team. His deep-rooted passion for Kashmir’s beauty and culture led him to establish this venture, blending adventure, comfort, and cultural immersion into one unforgettable experience. With a meticulous eye for detail, he ensures every aspect of the travel experience meets the highest standards.",
    },
    {
        name: "Nazir Reshi",
        position: "Co-Founder & Senior Guide",
        src: "/images/about/nazir.jpg",
        description:
            "Our Co-Founder and Senior Guide, is an expert in adventure tourism with exceptional guiding skills. A highly skilled skiing instructor and outdoor enthusiast, he specializes in high-altitude trekking, mountaineering, and various adventure activities. His deep understanding of Kashmir’s terrain and his ability to craft unique travel experiences make him an invaluable asset to our team and travelers alike.",
    },
    {
        name: "Saleem",
        position: "Head of Operations & Skiing Instructor",
        src: "/images/about/salim.jpg",
        description:
            "Our Head of Operations and one of the finest skiing instructors, has years of experience guiding adventurers across Kashmir. His expertise in winter sports, coupled with his deep knowledge of the region’s landscapes and history, ensures that travelers get an authentic and thrilling experience. Whether it’s backcountry skiing, snowboarding, or organizing seamless tour logistics, Saleem’s dedication guarantees top-notch adventure trips.",
    },
    {
        name: "Rayees Lone",
        position: "Adventure Coordinator",
        src: rayees,
        description:
            "Our Adventure Coordinator and Senior Tourist Guide, is a seasoned explorer with a deep love for nature and outdoor activities. With extensive experience in organizing treks and adventure sports, Rayees ensures our guests enjoy the thrill of Kashmir’s terrains while maintaining the highest safety standards. His dedication to adventure tourism brings a spirit of excitement and exploration to every tour.",
    },
    {
        name: "Iqbal",
        position: "Marketing Head & Skiing Instructor",
        src: "/images/about/iqbal.jpg",
        description:
            "Our Marketing Head and expert skiing instructor, blends his passion for winter sports with strategic branding. His creative marketing campaigns capture the essence of Kashmir’s adventure tourism, attracting global travelers. With years of experience both in digital storytelling and on the slopes, Iqbal plays a crucial role in promoting skiing and adventure activities while ensuring travelers get the best of what Kashmir has to offer.",
    },
];
  
  export default teamData;
  